export default __webpack_public_path__ + "static/media/shape5mobile.f08692dd.svg";